// @flow
type StateType = {
  nextPage: number,
  loading: boolean
};

const defaultState = {
  nextPage: 1,
  loading: true
};

export default function bandSearch (state: StateType = defaultState, action: any) {
  switch (action.type) {
    case 'INCREMENT_NEXT_BANDS_PAGE':
      return {
        ...state,
        nextPage: state.nextPage + 1
      };

    case 'RESET_NEXT_BANDS_PAGE':
      return {
        ...state,
        nextPage: 1
      };

    case 'FETCH_BANDS_STARTED':
      return {
        ...state,
        loading: true
      };

    case 'FETCH_BANDS_SUCCESS':
      return {
        ...state,
        loading: false
      };

    default:
      return state;
  }
}
